import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import { useCareerYagiofferHistories } from '@/composables/format-edit/useCareerYagiofferHistories'
import {
  createEmptyNewYagiofferFormatData,
  provideNewYagiofferFormatData
} from '@/composables/format-edit/useNewYagiofferFormat'
import NewYagiofferEduHistoryCard from './NewYagiofferEduHistoryCard.vue'
import NewYagiofferRequestsCard from './NewYagiofferRequestsCard.vue'
import DownloadItem from '@/components/formats/CommonParts/YagiofferDownloadItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewYagiofferEdit',
  props: {
    basicData: null,
    formatId: null,
    previewFormat: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any) {

const props = __props as {
  basicData: Record<string, unknown>
  formatId?: string
  previewFormat?: { errorMessages?: Record<string, string> } | null
  currentCardId?: string
  exampleSentences?: Record<string, unknown>
};



const { formLib } = useHostServices()

const { formatData } = useFormatLocalData({
  saveName: 'rirekisho',
  saveOtherName: 'shokumukeirekisho',
  createEmpty: createEmptyNewYagiofferFormatData
})
provideNewYagiofferFormatData(formatData)

const {
  activeHistoryItem,
  educationalResetDialogVisible,
  setEducationalBackgrounds,
  resetEducationalBackgrounds,
  addEducationalHistory,
  deleteEducationalHistory,
  moveEducationalHistory,
  activateHistoryItem
} = useCareerYagiofferHistories(formatData)

const descriptionMaxLength = 80
const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiPostEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)
const downloadActiveCollapses = ref(['postcard'])
const isSendedYagishIntern = ref(false)

const previewErrors = computed(() => {
  if (!props.previewFormat || !props.previewFormat.errorMessages) return {}
  return props.previewFormat.errorMessages
})

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

function setIsSendedYagishIntern(rslt: boolean) {
  isSendedYagishIntern.value = rslt
}

watch(
  () => formatData.createDate,
  (newValue) => {
    if (newValue == null) return
    formatData.writeDate = formLib.dateFormat(
      newValue as Date,
      'yyyy年 m月 d日'
    )
  }
)

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  formatData.registYagioffer = true
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
  emitter.on('set_is_sendedYagishIntern', setIsSendedYagishIntern)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
  emitter.off('set_is_sendedYagishIntern', setIsSendedYagishIntern)
})

return { __sfc: true,props, formLib, formatData, activeHistoryItem, educationalResetDialogVisible, setEducationalBackgrounds, resetEducationalBackgrounds, addEducationalHistory, deleteEducationalHistory, moveEducationalHistory, activateHistoryItem, descriptionMaxLength, mailPdfEnabled, downloadPdfEnabled, isSendYagiPostEnabled, isSendYagiEmailEnabled, downloadActiveCollapses, isSendedYagishIntern, previewErrors, dataChanged, setIsSendedYagishIntern, NewYagiofferEduHistoryCard, NewYagiofferRequestsCard, DownloadItem }
}

})